@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package bashbuddy.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi

private object CommonMainDrawable0 {
  public val avatar: DrawableResource by 
      lazy { init_avatar() }

  public val bash_buddy_logo: DrawableResource by 
      lazy { init_bash_buddy_logo() }

  public val bash_buddy_topbar_logo: DrawableResource by 
      lazy { init_bash_buddy_topbar_logo() }

  public val bash_ticket_info_sample: DrawableResource by 
      lazy { init_bash_ticket_info_sample() }

  public val bookmark_selected: DrawableResource by 
      lazy { init_bookmark_selected() }

  public val bookmark_unselected: DrawableResource by 
      lazy { init_bookmark_unselected() }

  public val cart_selected: DrawableResource by 
      lazy { init_cart_selected() }

  public val cart_unselected: DrawableResource by 
      lazy { init_cart_unselected() }

  public val compose_multiplatform: DrawableResource by 
      lazy { init_compose_multiplatform() }

  public val dashboard_filled: DrawableResource by 
      lazy { init_dashboard_filled() }

  public val dashboard_outline: DrawableResource by 
      lazy { init_dashboard_outline() }

  public val favorite_filled: DrawableResource by 
      lazy { init_favorite_filled() }

  public val favorite_outline: DrawableResource by 
      lazy { init_favorite_outline() }

  public val home_selected: DrawableResource by 
      lazy { init_home_selected() }

  public val home_unselected: DrawableResource by 
      lazy { init_home_unselected() }

  public val ic_launcher: DrawableResource by 
      lazy { init_ic_launcher() }

  public val profile_dummy: DrawableResource by 
      lazy { init_profile_dummy() }

  public val profile_selected: DrawableResource by 
      lazy { init_profile_selected() }

  public val profile_unselected: DrawableResource by 
      lazy { init_profile_unselected() }

  public val pull_tab_ticket_info: DrawableResource by 
      lazy { init_pull_tab_ticket_info() }

  public val recipe_app_logo: DrawableResource by 
      lazy { init_recipe_app_logo() }

  public val search_filled: DrawableResource by 
      lazy { init_search_filled() }

  public val search_outline: DrawableResource by 
      lazy { init_search_outline() }

  public val sign_in_selected: DrawableResource by 
      lazy { init_sign_in_selected() }

  public val sign_in_unselected: DrawableResource by 
      lazy { init_sign_in_unselected() }

  public val sign_up_selected: DrawableResource by 
      lazy { init_sign_up_selected() }

  public val sign_up_unselected: DrawableResource by 
      lazy { init_sign_up_unselected() }

  public val sure_tip_ticket_info: DrawableResource by 
      lazy { init_sure_tip_ticket_info() }

  public val ticket_example: DrawableResource by 
      lazy { init_ticket_example() }
}

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("avatar", CommonMainDrawable0.avatar)
  map.put("bash_buddy_logo", CommonMainDrawable0.bash_buddy_logo)
  map.put("bash_buddy_topbar_logo", CommonMainDrawable0.bash_buddy_topbar_logo)
  map.put("bash_ticket_info_sample", CommonMainDrawable0.bash_ticket_info_sample)
  map.put("bookmark_selected", CommonMainDrawable0.bookmark_selected)
  map.put("bookmark_unselected", CommonMainDrawable0.bookmark_unselected)
  map.put("cart_selected", CommonMainDrawable0.cart_selected)
  map.put("cart_unselected", CommonMainDrawable0.cart_unselected)
  map.put("compose_multiplatform", CommonMainDrawable0.compose_multiplatform)
  map.put("dashboard_filled", CommonMainDrawable0.dashboard_filled)
  map.put("dashboard_outline", CommonMainDrawable0.dashboard_outline)
  map.put("favorite_filled", CommonMainDrawable0.favorite_filled)
  map.put("favorite_outline", CommonMainDrawable0.favorite_outline)
  map.put("home_selected", CommonMainDrawable0.home_selected)
  map.put("home_unselected", CommonMainDrawable0.home_unselected)
  map.put("ic_launcher", CommonMainDrawable0.ic_launcher)
  map.put("profile_dummy", CommonMainDrawable0.profile_dummy)
  map.put("profile_selected", CommonMainDrawable0.profile_selected)
  map.put("profile_unselected", CommonMainDrawable0.profile_unselected)
  map.put("pull_tab_ticket_info", CommonMainDrawable0.pull_tab_ticket_info)
  map.put("recipe_app_logo", CommonMainDrawable0.recipe_app_logo)
  map.put("search_filled", CommonMainDrawable0.search_filled)
  map.put("search_outline", CommonMainDrawable0.search_outline)
  map.put("sign_in_selected", CommonMainDrawable0.sign_in_selected)
  map.put("sign_in_unselected", CommonMainDrawable0.sign_in_unselected)
  map.put("sign_up_selected", CommonMainDrawable0.sign_up_selected)
  map.put("sign_up_unselected", CommonMainDrawable0.sign_up_unselected)
  map.put("sure_tip_ticket_info", CommonMainDrawable0.sure_tip_ticket_info)
  map.put("ticket_example", CommonMainDrawable0.ticket_example)
}

internal val Res.drawable.avatar: DrawableResource
  get() = CommonMainDrawable0.avatar

private fun init_avatar(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:avatar",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/avatar.webp", -1, -1),
    )
)

internal val Res.drawable.bash_buddy_logo: DrawableResource
  get() = CommonMainDrawable0.bash_buddy_logo

private fun init_bash_buddy_logo(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:bash_buddy_logo",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/bash_buddy_logo.png", -1, -1),
    )
)

internal val Res.drawable.bash_buddy_topbar_logo: DrawableResource
  get() = CommonMainDrawable0.bash_buddy_topbar_logo

private fun init_bash_buddy_topbar_logo(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:bash_buddy_topbar_logo",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/bash_buddy_topbar_logo.png", -1, -1),
    )
)

internal val Res.drawable.bash_ticket_info_sample: DrawableResource
  get() = CommonMainDrawable0.bash_ticket_info_sample

private fun init_bash_ticket_info_sample(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:bash_ticket_info_sample",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/bash_ticket_info_sample.png", -1, -1),
    )
)

internal val Res.drawable.bookmark_selected: DrawableResource
  get() = CommonMainDrawable0.bookmark_selected

private fun init_bookmark_selected(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:bookmark_selected",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/bookmark_selected.png", -1, -1),
    )
)

internal val Res.drawable.bookmark_unselected: DrawableResource
  get() = CommonMainDrawable0.bookmark_unselected

private fun init_bookmark_unselected(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:bookmark_unselected",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/bookmark_unselected.png", -1, -1),
    )
)

internal val Res.drawable.cart_selected: DrawableResource
  get() = CommonMainDrawable0.cart_selected

private fun init_cart_selected(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:cart_selected",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/cart_selected.xml", -1, -1),
    )
)

internal val Res.drawable.cart_unselected: DrawableResource
  get() = CommonMainDrawable0.cart_unselected

private fun init_cart_unselected(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:cart_unselected",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/cart_unselected.xml", -1, -1),
    )
)

internal val Res.drawable.compose_multiplatform: DrawableResource
  get() = CommonMainDrawable0.compose_multiplatform

private fun init_compose_multiplatform(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:compose_multiplatform",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/compose-multiplatform.xml", -1, -1),
    )
)

internal val Res.drawable.dashboard_filled: DrawableResource
  get() = CommonMainDrawable0.dashboard_filled

private fun init_dashboard_filled(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:dashboard_filled",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/dashboard_filled.xml", -1, -1),
    )
)

internal val Res.drawable.dashboard_outline: DrawableResource
  get() = CommonMainDrawable0.dashboard_outline

private fun init_dashboard_outline(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:dashboard_outline",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/dashboard_outline.xml", -1, -1),
    )
)

internal val Res.drawable.favorite_filled: DrawableResource
  get() = CommonMainDrawable0.favorite_filled

private fun init_favorite_filled(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:favorite_filled",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/favorite_filled.xml", -1, -1),
    )
)

internal val Res.drawable.favorite_outline: DrawableResource
  get() = CommonMainDrawable0.favorite_outline

private fun init_favorite_outline(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:favorite_outline",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/favorite_outline.xml", -1, -1),
    )
)

internal val Res.drawable.home_selected: DrawableResource
  get() = CommonMainDrawable0.home_selected

private fun init_home_selected(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:home_selected",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/home_selected.png", -1, -1),
    )
)

internal val Res.drawable.home_unselected: DrawableResource
  get() = CommonMainDrawable0.home_unselected

private fun init_home_unselected(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:home_unselected",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/home_unselected.png", -1, -1),
    )
)

internal val Res.drawable.ic_launcher: DrawableResource
  get() = CommonMainDrawable0.ic_launcher

private fun init_ic_launcher(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_launcher",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/ic_launcher.png", -1, -1),
    )
)

internal val Res.drawable.profile_dummy: DrawableResource
  get() = CommonMainDrawable0.profile_dummy

private fun init_profile_dummy(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:profile_dummy",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/profile_dummy.png", -1, -1),
    )
)

internal val Res.drawable.profile_selected: DrawableResource
  get() = CommonMainDrawable0.profile_selected

private fun init_profile_selected(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:profile_selected",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/profile_selected.png", -1, -1),
    )
)

internal val Res.drawable.profile_unselected: DrawableResource
  get() = CommonMainDrawable0.profile_unselected

private fun init_profile_unselected(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:profile_unselected",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/profile_unselected.png", -1, -1),
    )
)

internal val Res.drawable.pull_tab_ticket_info: DrawableResource
  get() = CommonMainDrawable0.pull_tab_ticket_info

private fun init_pull_tab_ticket_info(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:pull_tab_ticket_info",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/pull_tab_ticket_info.png", -1, -1),
    )
)

internal val Res.drawable.recipe_app_logo: DrawableResource
  get() = CommonMainDrawable0.recipe_app_logo

private fun init_recipe_app_logo(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:recipe_app_logo",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/recipe_app_logo.png", -1, -1),
    )
)

internal val Res.drawable.search_filled: DrawableResource
  get() = CommonMainDrawable0.search_filled

private fun init_search_filled(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:search_filled",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/search_filled.xml", -1, -1),
    )
)

internal val Res.drawable.search_outline: DrawableResource
  get() = CommonMainDrawable0.search_outline

private fun init_search_outline(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:search_outline",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/search_outline.xml", -1, -1),
    )
)

internal val Res.drawable.sign_in_selected: DrawableResource
  get() = CommonMainDrawable0.sign_in_selected

private fun init_sign_in_selected(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:sign_in_selected",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/sign_in_selected.png", -1, -1),
    )
)

internal val Res.drawable.sign_in_unselected: DrawableResource
  get() = CommonMainDrawable0.sign_in_unselected

private fun init_sign_in_unselected(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:sign_in_unselected",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/sign_in_unselected.png", -1, -1),
    )
)

internal val Res.drawable.sign_up_selected: DrawableResource
  get() = CommonMainDrawable0.sign_up_selected

private fun init_sign_up_selected(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:sign_up_selected",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/sign_up_selected.png", -1, -1),
    )
)

internal val Res.drawable.sign_up_unselected: DrawableResource
  get() = CommonMainDrawable0.sign_up_unselected

private fun init_sign_up_unselected(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:sign_up_unselected",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/sign_up_unselected.png", -1, -1),
    )
)

internal val Res.drawable.sure_tip_ticket_info: DrawableResource
  get() = CommonMainDrawable0.sure_tip_ticket_info

private fun init_sure_tip_ticket_info(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:sure_tip_ticket_info",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/sure_tip_ticket_info.png", -1, -1),
    )
)

internal val Res.drawable.ticket_example: DrawableResource
  get() = CommonMainDrawable0.ticket_example

private fun init_ticket_example(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ticket_example",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/drawable/ticket_example.png", -1, -1),
    )
)
